
var formAnimate = Fw.component.models().formAnimate;
var login = Fw.component.models().login;
var profile = Fw.component.models().profile;
var tools = Fw.component.models().tools;
var formValidator = Fw.component.models().form;
var session = Fw.component.models().session;
var labels = Fw.component.models().labels;
var slider = Fw.component.models().slider;

(function($, undefined) {

    'use strict';

    var isLoggedIn = false;
    var isMobile = false;
    var noScroll = false;
    var menuOpen = false;
    var win = $(window);
    var winWidth;
    var winHeight;
    var header;
    var navItems;
    var searchBar;
    var searchBtn;
    var searchOpenBtn;
    var searchCloseBtn;
    var pagerPerPage;
    var toggleMenuBtn;
    var respDetectionSmScreen;
    var respDetectionPhScreen;
    var profilesCtn;
    var loggedWithoutProfile;
    var accountValidatedPopup;

    var toggleScroll = function() {
        var diff;

        if ($('body').hasClass('no-scroll')) {
            // $('html').removeClass('no-scroll');
            $('body').removeClass('no-scroll');
            diff = 0;
            noScroll = false;
        } else {
            var w1 = win.width();
            // $('html').addClass('no-scroll');
            $('body').addClass('no-scroll');
            var w2 = win.width();
            diff = w2 - w1;
            noScroll = true;
        }

        changeScrollDiff(diff);
    };

    var changeScrollDiff = function(diff) {
        if (diff === 0) {
            $('.js-scroll-padding').removeAttr('style');
            $('.js-scroll-right').removeAttr('style');
        } else {
            $('.js-scroll-padding').css('padding-right', diff + 'px');
            $('.js-scroll-right').css('right', diff + 'px');
        }
    };
    var checkClick = function(event){
        if(!$(event.target).closest('.sidenav-dashboard').length && !$(event.target).closest('.site-nav').length){
           if (!!header.hasClass('menu-open')) {
                onClickMenuToggle();
            }
        }
    };
    var onClickMenuToggle = function() {
        
        if (!!header.hasClass('menu-open')) {
            var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
            header.removeClass('menu-open');
            menuOpen = false;

            header.on(transitionEnd, function(e) {
                $('body').removeClass('no-scroll');
                $('html').removeClass('no-scroll');
                noScroll = false;
                changeScrollDiff(0);
                $(this).off(e);
            });
        } else {
            var target = 0;

            if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
                target = $('.site-header').offset().top;
            }

            if (win.scrollTop() <= $('.site-header').offset().top) {
                $('html, body').animate({scrollTop: target}, 10, function() {
                    openMenu();
                });
            } else {
                openMenu();
            }
            menuOpen = true;
        }
    };

    var checkScreenWidth = function() {
        if (profilesCtn.hasClass('open') || $('body').find('.popup.slide-in.open').length) {
            if (respDetectionSmScreen.css('visibility') !== 'visible') {
                if (noScroll === true) {
                    toggleScroll();
                }
            } else {
                if (noScroll === false) {
                    toggleScroll();
                }
            }
        } else if (menuOpen === true) {
            if (respDetectionPhScreen.css('visibility') !== 'visible') {
                if (noScroll === true) {
                    toggleScroll();
                }
            } else {
                if (noScroll === false) {
                    toggleScroll();
                }
            }
        }
    };

    var openMenu = function() {
        header.addClass('menu-open');
        menuOpen = true;

        if (respDetectionPhScreen.css('visibility') === 'visible' && noScroll === false) {
            toggleScroll();
        }
    };

    var closeMenu = function() {
        if (header.hasClass('menu-open')) {
            header.removeClass('menu-open');
            menuOpen = false;

            if (respDetectionPhScreen.css('visibility') === 'visible' && noScroll === true) {
                toggleScroll();
            }
        }
    };

    var updateNavSelected = function(page) {
        navItems.removeClass('selected');
        var handleObj = $('.main-content ' + page);
        var handle = handleObj.attr('data-page-nav');

        navItems.each(function() {
            var t = $(this);

            if (t.data('pageNav') === handle) {
                t.addClass('selected');
            }
        });
    };

    var menuScroll = function() {
        if (window.pageYOffset !== 0) {
            $(".site-header").addClass("site-header-scroll");
        }
        else {
            if (!header.hasClass("site-header-connect")) {
                $(".site-header").removeClass("site-header-scroll");
            }
        }
    };

    /*var pageEnter = function (page) {
     updateNavSelected(page);
     };*/

    var openSearch = function(e) {
        searchBar.addClass("search-open");

        searchOpenBtn  = $(".search-ctn.search-open .search-btn", header);
        searchOpenBtn.on('click', submitSearch);
    };
    
    var openSearch2= function(e) {
        e.preventDefault();
        openSearch();
        searchBar.find(".input").focus();
    };

    var submitSearch = function() {
        $(this).closest('form').submit();
    };

    var closeSearch = function(e) {
        searchOpenBtn.off('click', submitSearch);
        searchBar.removeClass("search-open");
    };

    var changePerPage = function() {
        var t = $(this);
        var perPage = t.val();
        var page = t.attr("data-extra");
        var ctn = t.closest('.save-per-page');

        if (ctn.length) {
            ajax("/action/sessionVariables?key=perPage&value=" + perPage, function(){               
                loadPerPage(page, perPage);
            },true);
        } else { 
            loadPerPage(page, perPage);
        }
    };
    
    var loadPerPage = function(page, perPage) {
        if (page.indexOf("?") === -1) {
            window.location = page + "?perPage=" + perPage;
        }
        else {
            window.location = page + "&perPage=" + perPage;
        }
    };
    
    function prlx() {
        var rate = 60,
        scroller = 0,
        y = 0,
        dy, sy, ey, el, em, ctn, h, elm;
        
        el = document.querySelector(".prlx-el");
        em = document.querySelector(".prlx-em");
        if (el) {
            ctn = el.parentElement;
            _scrl();
            _trans();
            window.addEventListener("scroll", _scrl);
        }
        
        function _scrl() {
            scroller = rate;
            h = ctn.clientHeight;
            sy = window.scrollY;
        }
        function _trans() {
            if (scroller > 0) {
                scroller--;
                dy = (sy - y) / 1.414;
                y += dy;
                if (sy <= h) {
                    if (scroller === 0) y = sy;
                    ey = y / 3;
                    domCbTransform(el, "translate3d(0," + ey + "px,0)");
                    domCbTransform(em, "translate3d(0," + ey * -1.5 + "px,0)");
                }
            }
            rAF(_trans);
        }
    };
    
    function cbTransform(arg){
        return {
            "-webkit-transform": arg,
            "-moz-transform": arg,
            "-ms-transform":arg,
            "transform": arg
        };
    }
    function domCbTransform(el, arg) {
        if (el) {
            var css = cbTransform(arg);
            for (var p in css) {
                el.style[p] = css[p];
            }
        }
    }

    var checkCMSLogout = function() {
        if (document.cookie.indexOf('loginFromDashboard') > -1) {
            var logoutForm = $('#formLogout');
            logoutForm.attr('action', $('.dashboard-logout').attr('href'));
            $('#logoutWindow button.button-primary').click(function(){document.cookie = 'loginFromDashboard=false;max-age=1';});
        }
    };

    var init = function() {
        profile.init();
        tools.init();
        slider.init();

        respDetectionPhScreen = $('.responsive-detector');
        respDetectionSmScreen = $('.responsive-detector-sm');
        profilesCtn = $('.my-profiles-window');
        header = $('.site-header');
        navItems = $('.nav-item-link', header);
        toggleMenuBtn = $('.site-header-menu-toggle-btn', header);
        loggedWithoutProfile = $('input[name="logged-without-profile"]', header);
        accountValidatedPopup = $('#validating-existing-account');

        // if logged in without having a profile
        var url = window.location.href;
        if (loggedWithoutProfile.length && url.indexOf(loggedWithoutProfile.val()) === -1 && !$("body").hasClass("is-admin")) {
            window.location.href = loggedWithoutProfile.val();
        }

        // if trying to validate while having a profile and account
        if (accountValidatedPopup.length) {
            accountValidatedPopup.addClass('open');
        }

        winWidth = win.width();
        winHeight = win.height();
        $('body').removeClass('no-scroll');
        $('html').removeClass('no-scroll');

        if ($('body').hasClass('is-logged-in')) {
            isLoggedIn = true;
        }

        toggleMenuBtn.on('click', onClickMenuToggle);
        $(document).on('click',checkClick);
        navItems.on('click', closeMenu);

        win.scroll(function() {
            menuScroll();
        });
        menuScroll();
        checkCMSLogout();

        /* On focus on the search input - start action */
        searchBar = $(".search-ctn", header);
        searchBar.find(".input").on("focus", openSearch);
        searchBtn = searchBar.find(".search-btn");
        searchBtn.click(openSearch2);
        searchCloseBtn = searchBar.find(".search-close");
        searchCloseBtn.on("click", closeSearch);

        pagerPerPage = $(".pager-select");
        pagerPerPage.on("change", changePerPage);

        win.resize(function() {
            if (win.width() != winWidth) {
                winHeight = win.height();
                winWidth = win.width();
            }
            if ($("#loginWindow").is(":visible") && $(".site-header-menu-toggle-ham").is(":visible")) {
                login.reinit();
                menuScroll();
            }

            checkScreenWidth();
        });
        formAnimate.init();
        if (!isLoggedIn) {
            login.init();
        }
        prlx();
    };

    $(window).on("load", function() {
        init();
    });

    var headerFunc = Fw.modules.export('header', {
        toggleScroll: toggleScroll
    });

})(jQuery);
